import { gql } from '@apollo/client';

export const SKIP_AUDIT_ITEM = gql`
  mutation SkipAuditItem($input: SkipAuditItemInput!) {
    skipAuditItem(input: $input) {
      item {
        id
        status
        auditSessionId
      }
    }
  }
`;

export const UNSKIP_AUDIT_ITEM = gql`
  mutation UnskipAuditItem($input: UnskipAuditItemInput!) {
    unskipAuditItem(input: $input) {
      item {
        id
        status
        auditSessionId
      }
    }
  }
`;
